import React from "react";
import NavigationDesktop from "./Navigation_desktop";
import NavigationMobile from "./Navigation_mobile";
import { useIsMobile } from "./hooks/use-mobile";

const NavigationWrapper = () => {
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? <NavigationMobile /> : <NavigationDesktop />}
    </>
  );
};

export default NavigationWrapper;